import { HandWaving, Info } from "@phosphor-icons/react";
import { cva } from "class-variance-authority";
import { clsx } from "clsx";

interface NotificationProps {
  title: string;
  subtitle?: string;
  variant: "red" | "gray" | "purple";
}

const iconContainerVariants = cva(
  "mr-1 rounded-md border p-px [&_svg]:size-4",
  {
    variants: {
      variant: {
        red: "border-red-200 bg-red-50 text-red-500",
        gray: "border-black-200 bg-black-50 ",
        purple: "border-purple-200 bg-purple-50 text-purple-500",
      },
    },
  },
);

export default function Notification({
  title,
  subtitle = null,
  variant,
}: NotificationProps) {
  return (
    <div
      className={clsx(
        "mx-4 mb-2 flex flex-wrap items-center justify-center gap-1 self-center rounded-2xl border bg-white px-2 py-1 shadow-sm lg:mx-0",
        variant === "red" ? "border-red-400" : "border-black-200",
      )}
    >
      <div className={iconContainerVariants({ variant })}>
        {variant === "purple" ? <HandWaving /> : <Info weight="fill" />}
      </div>

      <span className="text-xs-bold">{title}</span>

      {subtitle && (
        <span className="text-center text-xs text-black-600 lg:text-start">
          {subtitle}
        </span>
      )}
    </div>
  );
}
